import EventsService from "@/services/Events.js";
import { Default_post } from "@/library/lib.js"
// import moment from "moment";

const state = {
    loading: false,
    loaded: false,
    error: null,
    current_post: new Default_post,
    Posts: {
        page: 1,
        posts: []
    }
};

const actions = {
    async save_post(store, obj) {
        let send = new Default_post,
            post = obj.post;

        if (obj.route_params && !post.id) {
            send.event_id = obj.route_params.eventId;
        }
        else {
            send.event_id = post.event_id;
            send.id = post.id;
        }

        send.files = obj.post.files;
        send.text = post.text || '';
        send.title = post.title || '';
        send.button = post.button || '';
        send.promocode = post.promocode || '';
        send.link = post.link || '';

        if (!post.id) {
            return await EventsService.postCreate(send)
        } else {
            return await EventsService.postUpdate(send)
        }
    },
    load_single_post: function (state, obj = { event_id: '', post_id: '' }) {
        EventsService.postGet(
            obj
        ).then((post) => {
            state.commit('SET_CURRENT_POST', post.data);
        });
    },
    load_posts: function (state, obj = { event_id: '', page: 1 }) {
        EventsService.postsLoad(
            obj
        ).then((posts) => {
            state.commit('SET_POSTS', { posts: posts.data, page: obj.page })
        });
    },
    delete_post: async ({ commit }, obj = { event_id: '', post_id: '' }) => {
        const { event_id, post_id } = obj
        if (state.loading) {
            return
        }
        commit('POST_REQUEST')
        try {
            await EventsService.postDelete({ event_id, post_id })
            commit('POST_DELETE_SUCCESS', post_id)
        } catch (e) {
            commit('POST_ERROR', e)
        }
    },
}

const mutations = {
    POST_REQUEST: (state) => {
        state.loading = true
        state.loaded = false
    },
    POST_DELETE_SUCCESS: (state, post_id) => {
        state.loading = false
        state.loaded = true
        const { Posts } = state
        state.Posts.posts = Posts.posts.filter(post => post.id !== post_id)
    },
    SET_POSTS: (state, obj) => {
        state.Posts.page = obj.page;
        state.Posts.posts = obj.posts;
    },
    CLEAR_CURRENT_POST: state => {
        state.current_post = new Default_post
        state.loaded = true
    },
    SET_CURRENT_POST: (state, obj) => {
        state.current_post = { ...new Default_post, ...obj }
    }
}

const getters = {
    get_posts: state => {
        return { ...state.Posts };
    },
    get_current: state => {
        return { ...state.current_post };
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
